import React, { useMemo } from 'react';
import { createColumnHelper } from "@tanstack/react-table";
import { useNavigate } from "react-router-dom";
import TanStackTable from "../../components/TanStackTable";
import Chip from "../../components/Chip";
import { FaEye } from "react-icons/fa";

const dummyData = [
    {
        _id: "507f1f77bcf86cd799439011",
        campaign: 'Sponsor a Challenge',
        landingPageUrl: 'https://example.com/sponsor-challenge',
        ctaButtonText: 'VISIT NOW',
        message: 'Aute cupidatat magna amet cupidatat laboris laboris occaecat elit veniam. Sint mollit laboris magna mollit nisi occaecat magna labore irure ipsum. Eu nisi minim sit Lorem nostrud enim.',
        startDate: '2025-07-05T04:09:57.999+00:00',
        endDate: '2025-07-12T04:09:57.999+00:00',
        active: true,
        createdAt: '2025-07-05T04:09:57.999+00:00',
        updatedAt: '2025-07-05T04:09:57.999+00:00',
        __v: 0,
        imageUrl: '',
        NGOId: {
            _id: "507f191e810c19729de860ea",
            name: "Green Earth NGO",
        },
        companyId: null,
    },
    {
        _id: "507f1f77bcf86cd799439012",
        campaign: 'Clean Ocean Initiative',
        landingPageUrl: 'https://example.com/clean-ocean',
        ctaButtonText: 'JOIN US',
        message: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.',
        startDate: '2025-07-10T04:09:57.999+00:00',
        endDate: '2025-07-20T04:09:57.999+00:00',
        active: false,
        createdAt: '2025-07-10T04:09:57.999+00:00',
        updatedAt: '2025-07-10T04:09:57.999+00:00',
        __v: 0,
        imageUrl: '',
        NGOId: null,
        companyId: {
            _id: "507f191e810c19729de860ed",
            name: "EcoTech Solutions",
        },
    },
    {
        _id: "507f1f77bcf86cd799439013",
        campaign: 'Forest Restoration Project',
        landingPageUrl: 'https://example.com/forest-restoration',
        ctaButtonText: 'LEARN MORE',
        message: 'Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident.',
        startDate: '2025-08-01T04:09:57.999+00:00',
        endDate: '2025-08-15T04:09:57.999+00:00',
        active: true,
        createdAt: '2025-08-01T04:09:57.999+00:00',
        updatedAt: '2025-08-01T04:09:57.999+00:00',
        __v: 0,
        imageUrl: '',
        NGOId: null,
        companyId: {
            _id: "507f191e810c19729de860ef",
            name: "GreenTech Innovations",
        }
    },
    {
        _id: "507f1f77bcf86cd799439014",
        campaign: 'Renewable Energy Campaign',
        landingPageUrl: 'https://example.com/renewable-energy',
        ctaButtonText: 'DONATE NOW',
        message: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis.',
        startDate: '2025-06-15T04:09:57.999+00:00',
        endDate: '2025-06-30T04:09:57.999+00:00',
        active: true,
        createdAt: '2025-06-15T04:09:57.999+00:00',
        updatedAt: '2025-06-15T04:09:57.999+00:00',
        __v: 0,
        imageUrl: '',
        NGOId: null,
        companyId: {
            _id: "507f191e810c19729de860f1",
            name: "EcoFuture Corp",
        },
    },
    {
        _id: "507f1f77bcf86cd799439015",
        campaign: 'Wildlife Conservation',
        landingPageUrl: 'https://example.com/wildlife-conservation',
        ctaButtonText: 'GET INVOLVED',
        message: 'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias.',
        startDate: '2025-09-01T04:09:57.999+00:00',
        endDate: '2025-09-14T04:09:57.999+00:00',
        active: false,
        createdAt: '2025-09-01T04:09:57.999+00:00',
        updatedAt: '2025-09-01T04:09:57.999+00:00',
        __v: 0,
        imageUrl: '',
        NGOId: {
            _id: "507f191e810c19729de860f2",
            name: "Wildlife Guardians",
        },
        companyId: null,
    },
    {
        _id: "507f1f77bcf86cd799439016",
        campaign: 'Sustainable Agriculture',
        landingPageUrl: 'https://example.com/sustainable-agriculture',
        ctaButtonText: 'SUPPORT US',
        message: 'Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt.',
        startDate: '2025-10-05T04:09:57.999+00:00',
        endDate: '2025-10-25T04:09:57.999+00:00',
        active: true,
        createdAt: '2025-10-05T04:09:57.999+00:00',
        updatedAt: '2025-10-05T04:09:57.999+00:00',
        __v: 0,
        imageUrl: '',
        NGOId: {
            _id: "507f191e810c19729de860f4",
            name: "Sustainable Future NGO",
        },
        companyId: null,
    },
];

const ListRequests = () => {
    const navigate = useNavigate();
    const columnHelper = createColumnHelper();

    const columns = useMemo(() => [
        columnHelper.display({
            id: 'srno',
            header: 'Sr No.',
            cell: info => info.row.index + 1,
        }),
        columnHelper.accessor('campaign', {
            header: 'Campaign Type',
            cell: info => (
                <div className="whitespace-normal break-words line-clamp-2">
                    {info.getValue() || 'N/A'}
                </div>
            ),
        }),
        columnHelper.accessor(row => row.NGOId || row.companyId, {
            id: 'sponsor',
            header: 'Sponsor',
            cell: info => {
                const ngoId = info.row.original.NGOId;
                const companyId = info.row.original.companyId;
                return (
                    <div className="whitespace-normal break-words line-clamp-2">
                        {ngoId?.name ? `NGO: ${ngoId?.name}` : companyId?.name ? `Company: ${companyId?.name}` : 'N/A'}
                    </div>
                );
            },
        }),
        columnHelper.accessor(row => `${row.startDate} - ${row.endDate}`, {
            id: 'duration',
            align: 'center',
            header: 'Duration',
            cell: info => {
                const startDate = new Date(info.row.original.startDate);
                const endDate = new Date(info.row.original.endDate);
                return (
                    <div className="whitespace-normal break-words">
                        {startDate.toRegularDate()} - {endDate.toRegularDate()}
                    </div>
                );
            },
        }),
        columnHelper.accessor('active', {
            header: () => <div className="text-center">Status</div>,
            align: 'center',
            cell: info => (
                <Chip value={info.getValue() ? 'Active' : 'Inactive'} color={info.getValue() ? 'green' : 'inactive'} />
            ),
        }),
        columnHelper.accessor('actions', {
            header: () => <div className="text-center">Actions</div>,
            enableColumnFilter: false,
            align: 'center',
            cell: info => {
                return (
                    <div className='flex items-center justify-center'>
                        <button
                            className="rounded p-1.5 bg-[rgba(52,199,89,0.1)] hover:bg-[rgba(52,199,89,0.2)] mx-1 min-h-7 min-w-7"
                            onClick={() => navigate('/requests/view-request', { state: { requestId: info.row.original?._id } })}
                            title="View Request"
                        >
                            <FaEye className="fill-primary" />
                        </button>
                    </div>
                )
            },
        }),
    ], [navigate]);

    return (
        <div>
            <section className="flex flex-col pt-5 w-full mt-5 bg-white rounded-md shadow-[0px_0px_25px_rgba(94,92,154,0.1)] max-md:max-w-full">
                <div className="flex flex-col pr-px w-full max-md:max-w-full">
                    <h1 className="self-start text-lg font-bold pl-6 pb-4">List of Create Campaign Requests</h1>
                    <div className="pl-5">
                        <TanStackTable
                            data={dummyData || []}
                            columns={columns}
                            enablePagination={true}
                        />
                    </div>
                </div>
            </section>
        </div>
    );
}

export default ListRequests;